import styled from 'styled-components';

export const SlideUpModalBox = styled.div<{ show: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 24px;
  padding-left: 12px;
  padding-right: 12px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  pointer-events: ${({ show }) => (show ? 'auto' : 'none')};
  transition-property: opacity;
  transition-duration: 200ms;
  transition-timing-function: linear;
  transition-delay: ${({ show }) => (show ? 0 : 300)}ms;

  @media (min-width: 768px) {
    padding-left: 92px;
    padding-right: 92px;
  }

  @media (min-height: 768px) {
    padding-top: 85px;
  }

  @media (min-height: 1000px) {
    padding-top: min(25vh, 200px);
  }

  @media (min-height: 1200px) {
    padding-top: max(30vh, 350px);
  }
`;

export const SlideUpModalContent = styled.div<{ show: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 1180px;
  height: 100vh;
  max-width: 100%;
  flex: 1;
  pointer-events: inherit;
  background-color: ${({ theme }) => (theme.colors.grey1)};
  -webkit-user-select: none;
  user-select: none;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
  overflow: hidden;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08),
              0 2px 24px rgba(0, 0, 0, 0.08);
  transform: translate3d(
    0,
    ${({ show }) => (show ? '0' : '100%')},
    0
  );
  transition-property: transform;
  transition-duration: ${({ show }) => (show ? 400 : 500)}ms;
  transition-timing-function: ease;
  transition-delay: ${({ show }) => (show ? 200 : 50)}ms;
`;
